import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../App';

const MESICE = ['Leden','Únor','Březen','Duben','Květen','Červen','Červenec','Srpen','Září','Říjen','Listopad','Prosinec'];

export default function SpravaSystemu({ onRefresh }) {
  const { profile: currentUser } = useAuth();
  
  const isVedouci = currentUser?.role === 'vedouci';
  const isHrOrJednatel = currentUser?.role === 'hr' || currentUser?.role === 'jednatel';
  
  const [tab, setTab] = useState(isVedouci ? 'zakazky' : 'uzivatele');
  const [uzivatele, setUzivatele] = useState([]);
  const [zakazky, setZakazky] = useState([]);
  const [uzavrene, setUzavrene] = useState([]);
  const [mojeTym, setMojeTym] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editUziv, setEditUziv] = useState(null);

  const [novyUziv, setNovyUziv] = useState({ jmeno:'', email:'', role:'zamestnanec', vedouci_ids:[], dovolena_narok: 20 });
  const [novaZak, setNovaZak] = useState({ nazev:'', datum_zahajeni:'', datum_ukonceni:'' });
  const [editZak, setEditZak] = useState(null);
  const [savingEditZ, setSavingEditZ] = useState(false);
  const [savingU, setSavingU] = useState(false);
  const [savingZ, setSavingZ] = useState(false);
  const [savingEdit, setSavingEdit] = useState(false);
  const [toastMsg, setToastMsg] = useState('');

  const now = new Date();
  const [uzRok, setUzRok] = useState(now.getFullYear());
  const [uzMesic, setUzMesic] = useState(now.getMonth() + 1);

  useEffect(() => { 
    if (currentUser) {
      fetchAll(); 
    }
  }, [currentUser]);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const zRes = await supabase.from('zakazky').select('*').order('nazev');
      setZakazky(zRes.data || []);

      if (isHrOrJednatel) {
        const [uRes, mRes] = await Promise.all([
          supabase.from('uzivatele').select('*').order('jmeno'),
          supabase.from('uzavrene_mesice').select('*').order('rok,mesic'),
        ]);
        setUzivatele(uRes.data || []);
        setUzavrene(mRes.data || []);
      } else if (isVedouci) {
        const tymRes = await supabase
          .from('zamestnanec_vedouci')
          .select('zamestnanec_id, uzivatele!zamestnanec_id(id, jmeno, email, role, aktivni)')
          .eq('vedouci_id', currentUser.id);
        const tym = (tymRes.data || []).map(v => v.uzivatele).filter(Boolean);
        setMojeTym(tym);
      }
    } catch (e) {
      toast('Chyba při načítání dat: ' + e.message);
    }
    setLoading(false);
  };

  const toast = (msg) => { setToastMsg(msg); setTimeout(() => setToastMsg(''), 3000); };

  const nacistVedouciIds = async (uzivatelId) => {
    const { data } = await supabase
      .from('zamestnanec_vedouci')
      .select('vedouci_id')
      .eq('zamestnanec_id', uzivatelId);
    return (data || []).map(v => v.vedouci_id);
  };

  const ulozitVedouciIds = async (uzivatelId, vedouciIds) => {
    await supabase.from('zamestnanec_vedouci').delete().eq('zamestnanec_id', uzivatelId);
    if (vedouciIds.length > 0) {
      await supabase.from('zamestnanec_vedouci').insert(
        vedouciIds.map(vid => ({ zamestnanec_id: uzivatelId, vedouci_id: vid }))
      );
    }
  };

  const pridatUzivatele = async () => {
    if (!novyUziv.jmeno || !novyUziv.email) return;
    setSavingU(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const prvniVedouci = novyUziv.vedouci_ids[0] || null;
      const response = await fetch(
        'https://chtyufnurkiyghrazhaa.supabase.co/functions/v1/invite-user',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${session.access_token}`,
          },
          body: JSON.stringify({
            jmeno: novyUziv.jmeno,
            email: novyUziv.email.toLowerCase().trim(),
            role: novyUziv.role,
            vedouci_id: prvniVedouci,
            dovolena_narok: novyUziv.dovolena_narok ?? 20,
          }),
        }
      );
      const result = await response.json();
      if (!response.ok) { toast('Chyba: ' + result.error); setSavingU(false); return; }

      if (novyUziv.vedouci_ids.length > 0 && result.id) {
        await ulozitVedouciIds(result.id, novyUziv.vedouci_ids);
      }

      if (result.id) {
        await supabase.from('uzivatele').update({ dovolena_narok: novyUziv.dovolena_narok ?? 20 }).eq('id', result.id);
      }

      toast('Uživatel přidán a pozvánka odeslána ✓');
      setNovyUziv({ jmeno:'', email:'', role:'zamestnanec', vedouci_ids:[], dovolena_narok: 20 });
      fetchAll();
      onRefresh();
    } catch (e) {
      toast('Chyba: ' + e.message);
    }
    setSavingU(false);
  };

  const otevritEditaci = async (u) => {
    const vedouciIds = await nacistVedouciIds(u.id);
    setEditUziv({ ...u, vedouci_ids: vedouciIds, dovolena_narok: u.dovolena_narok ?? 20, google_drive_url: u.google_drive_url || '' });
  };

  const ulozitEditaci = async () => {
    if (!editUziv.jmeno || !editUziv.email) return;
    setSavingEdit(true);
    const prvniVedouci = editUziv.vedouci_ids[0] || null;
    const { error } = await supabase.from('uzivatele').update({
      jmeno: editUziv.jmeno,
      email: editUziv.email.toLowerCase().trim(),
      role: editUziv.role,
      vedouci_id: prvniVedouci,
      dovolena_narok: editUziv.dovolena_narok ?? 20,
      google_drive_url: editUziv.google_drive_url || null,
    }).eq('id', editUziv.id);

    if (error) { toast('Chyba: ' + error.message); setSavingEdit(false); return; }

    await ulozitVedouciIds(editUziv.id, editUziv.vedouci_ids);

    toast('Uživatel upraven ✓');
    setEditUziv(null);
    fetchAll();
    onRefresh();
    setSavingEdit(false);
  };

  const toggleAktivni = async (u) => {
    await supabase.from('uzivatele').update({ aktivni: !u.aktivni }).eq('id', u.id);
    toast(u.aktivni ? 'Uživatel deaktivován' : 'Uživatel aktivován');
    fetchAll();
  };

  const pridatZakazku = async () => {
    if (!novaZak.nazev) return;
    setSavingZ(true);
    const { error } = await supabase.from('zakazky').insert({ nazev: novaZak.nazev, datum_zahajeni: novaZak.datum_zahajeni || null, datum_ukonceni: novaZak.datum_ukonceni || null });
    if (!error) { toast('Zakázka přidána ✓'); setNovaZak({ nazev:'', datum_zahajeni:'', datum_ukonceni:'' }); fetchAll(); }
    setSavingZ(false);
  };

  const ulozitEditZakazku = async () => {
    if (!editZak || !editZak.nazev) return;
    setSavingEditZ(true);
    const { error } = await supabase.from('zakazky').update({
      nazev: editZak.nazev,
      datum_zahajeni: editZak.datum_zahajeni || null,
      datum_ukonceni: editZak.datum_ukonceni || null,
    }).eq('id', editZak.id);
    if (!error) { toast('Zakázka upravena ✓'); setEditZak(null); fetchAll(); }
    else toast('Chyba: ' + error.message);
    setSavingEditZ(false);
  };

  const toggleZakazka = async (z) => {
    await supabase.from('zakazky').update({ uzavrena: !z.uzavrena }).eq('id', z.id);
    toast('Zakázka aktualizována ✓');
    fetchAll();
  };

  const uzavritMesic = async () => {
    const { error } = await supabase.from('uzavrene_mesice').insert({ rok: uzRok, mesic: uzMesic });
    if (error) { toast('Měsíc je již uzavřen nebo chyba'); } else { toast(`${MESICE[uzMesic-1]} ${uzRok} uzavřen ✓`); fetchAll(); }
  };

  const otevritMesic = async (id) => {
    await supabase.from('uzavrene_mesice').delete().eq('id', id);
    toast('Měsíc znovu otevřen');
    fetchAll();
  };

  const vedouci = uzivatele.filter(u => (u.role === 'vedouci' || u.role === 'jednatel' || u.role === 'hr') && u.aktivni);
  const inputStyle = { border: '1.5px solid #e2e8f0', borderRadius: 10, padding: '10px 14px', fontSize: 15, fontFamily: 'DM Sans, sans-serif', outline: 'none', width: '100%', boxSizing: 'border-box', background: '#fff' };

  const VedouciCheckboxy = ({ vedouciIds, onChange }) => (
    <div style={{ border: '1.5px solid #e2e8f0', borderRadius: 10, padding: '10px 14px', background: '#fff', display: 'flex', flexDirection: 'column', gap: 8 }}>
      {vedouci.length === 0 && <div style={{ fontSize: 13, color: '#888' }}>Žádní vedoucí k dispozici</div>}
      {vedouci.map(v => (
        <label key={v.id} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 14, color: '#333' }}>
          <input type="checkbox" checked={vedouciIds.includes(v.id)} onChange={() => onChange(v.id)} style={{ width: 16, height: 16, accentColor: '#2d6a4f', cursor: 'pointer' }} />
          {v.jmeno}
          <span style={{ fontSize: 12, color: '#aaa', marginLeft: 2 }}>({ {vedouci: 'Vedoucí', jednatel: 'Jednatel', hr: 'HR'}[v.role] })</span>
        </label>
      ))}
    </div>
  );

  const tabs = [
    ...(isHrOrJednatel ? [['uzivatele', '👥 Uživatelé']] : []),
    ['zakazky', '📋 Zakázky'],
    ...(isVedouci ? [['tym', '👥 Můj tým']] : []),
    ...(isHrOrJednatel ? [['mesice', '🔒 Měsíce']] : []),
  ];

  return (
    <div>
      {toastMsg && (
        <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 1000, background: '#2d6a4f', color: '#fff', padding: '12px 20px', borderRadius: 12, fontWeight: 600, fontSize: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.2)' }}>
          {toastMsg}
        </div>
      )}

      {editUziv && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 500, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: '100%', maxWidth: 480, boxSizing: 'border-box', boxShadow: '0 20px 60px rgba(0,0,0,0.25)', fontFamily: 'DM Sans, sans-serif', maxHeight: '90vh', overflowY: 'auto' }}>
            <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 20, color: '#111' }}>Upravit uživatele</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {[['Jméno a příjmení','jmeno','text'],['E-mail','email','email']].map(([lbl,key,type]) => (
                <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>{lbl}</label>
                  <input type={type} value={editUziv[key]} onChange={e => setEditUziv({...editUziv, [key]: e.target.value})} style={inputStyle} />
                </div>
              ))}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Role</label>
                <select value={editUziv.role} onChange={e => setEditUziv({...editUziv, role: e.target.value})} style={inputStyle}>
                  <option value="zamestnanec">Zaměstnanec</option>
                  <option value="vedouci">Vedoucí</option>
                  <option value="jednatel">Jednatel</option>
                  <option value="hr">HR / Admin</option>
                </select>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Nárok dovolené (dní)</label>
                <input
                  type="number" min="0" max="365" step="0.25"
                  value={editUziv.dovolena_narok ?? 20}
                  onChange={e => setEditUziv({...editUziv, dovolena_narok: parseFloat(e.target.value) || 0})}
                  style={inputStyle}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>📁 Odkaz na Google Drive</label>
                <input
                  type="url"
                  placeholder="https://drive.google.com/..."
                  value={editUziv.google_drive_url || ''}
                  onChange={e => setEditUziv({...editUziv, google_drive_url: e.target.value})}
                  style={inputStyle}
                />
              </div>
              {(editUziv.role === 'zamestnanec' || editUziv.role === 'vedouci') && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Vedoucí (lze vybrat více)</label>
                  <VedouciCheckboxy
                    vedouciIds={editUziv.vedouci_ids}
                    onChange={(id) => {
                      const ids = editUziv.vedouci_ids.includes(id) ? editUziv.vedouci_ids.filter(v => v !== id) : [...editUziv.vedouci_ids, id];
                      setEditUziv({ ...editUziv, vedouci_ids: ids });
                    }}
                  />
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
              <button onClick={() => setEditUziv(null)} style={{ flex: 1, background: '#f1f5f9', border: 'none', borderRadius: 10, padding: 13, fontSize: 14, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', fontWeight: 600, color: '#555' }}>Zrušit</button>
              <button onClick={ulozitEditaci} disabled={savingEdit} style={{ flex: 2, background: '#2d6a4f', color: '#fff', border: 'none', borderRadius: 10, padding: 13, fontSize: 14, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', fontWeight: 700 }}>
                {savingEdit ? 'Ukládám…' : 'Uložit změny'}
              </button>
            </div>
          </div>
        </div>
      )}

      {editZak && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 500, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: '100%', maxWidth: 480, boxSizing: 'border-box', boxShadow: '0 20px 60px rgba(0,0,0,0.25)', fontFamily: 'DM Sans, sans-serif' }}>
            <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 20, color: '#111' }}>Upravit zakázku</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Název zakázky</label>
                <input value={editZak.nazev} onChange={e => setEditZak({...editZak, nazev: e.target.value})} style={inputStyle} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Datum zahájení</label>
                <input type="date" value={editZak.datum_zahajeni || ''} onChange={e => setEditZak({...editZak, datum_zahajeni: e.target.value})} style={inputStyle} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Datum ukončení (volitelné)</label>
                <input type="date" value={editZak.datum_ukonceni || ''} onChange={e => setEditZak({...editZak, datum_ukonceni: e.target.value})} style={inputStyle} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
              <button onClick={() => setEditZak(null)} style={{ flex: 1, background: '#f1f5f9', border: 'none', borderRadius: 10, padding: 13, fontSize: 14, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', fontWeight: 600, color: '#555' }}>Zrušit</button>
              <button onClick={ulozitEditZakazku} disabled={savingEditZ} style={{ flex: 2, background: '#2d6a4f', color: '#fff', border: 'none', borderRadius: 10, padding: 13, fontSize: 14, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', fontWeight: 700 }}>
                {savingEditZ ? 'Ukládám…' : 'Uložit změny'}
              </button>
            </div>
          </div>
        </div>
      )}

      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 16, color: '#111' }}>Správa systému</h2>

      <div style={{ display: 'flex', gap: 6, marginBottom: 20, flexWrap: 'wrap' }}>
        {tabs.map(([val, lbl]) => (
          <button key={val} onClick={() => setTab(val)} style={{
            background: tab === val ? '#2d6a4f' : '#fff',
            color: tab === val ? '#fff' : '#555',
            border: '1.5px solid ' + (tab === val ? '#2d6a4f' : '#e2e8f0'),
            borderRadius: 20, padding: '7px 16px', fontSize: 13, fontWeight: 600,
            cursor: 'pointer', fontFamily: 'DM Sans, sans-serif',
          }}>{lbl}</button>
        ))}
      </div>

      {loading ? <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#888' }}>Načítám…</div> : (
        <>
          {tab === 'uzivatele' && isHrOrJednatel && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div style={{ background: '#fff', borderRadius: 14, padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
                <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 14, color: '#111' }}>Přidat uživatele</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {[['Jméno a příjmení','jmeno','text','Jan Novák'],['E-mail','email','email','jan@firma.cz']].map(([lbl,key,type,ph]) => (
                    <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                      <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>{lbl}</label>
                      <input type={type} value={novyUziv[key]} onChange={e => setNovyUziv({...novyUziv, [key]: e.target.value})} placeholder={ph} style={inputStyle} />
                    </div>
                  ))}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                    <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Role</label>
                    <select value={novyUziv.role} onChange={e => setNovyUziv({...novyUziv, role: e.target.value})} style={inputStyle}>
                      <option value="zamestnanec">Zaměstnanec</option>
                      <option value="vedouci">Vedoucí</option>
                      <option value="jednatel">Jednatel</option>
                      <option value="hr">HR / Admin</option>
                    </select>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                    <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Nárok dovolené (dní)</label>
                    <input
                      type="number" min="0" max="365" step="0.25"
                      value={novyUziv.dovolena_narok}
                      onChange={e => setNovyUziv({...novyUziv, dovolena_narok: parseFloat(e.target.value) || 0})}
                      style={inputStyle}
                    />
                  </div>
                  {(novyUziv.role === 'zamestnanec' || novyUziv.role === 'vedouci') && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                      <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Vedoucí (lze vybrat více)</label>
                      <VedouciCheckboxy
                        vedouciIds={novyUziv.vedouci_ids}
                        onChange={(id) => {
                          const ids = novyUziv.vedouci_ids.includes(id) ? novyUziv.vedouci_ids.filter(v => v !== id) : [...novyUziv.vedouci_ids, id];
                          setNovyUziv({ ...novyUziv, vedouci_ids: ids });
                        }}
                      />
                    </div>
                  )}
                  <p style={{ fontSize: 12, color: '#888', marginTop: 4 }}>Po přidání bude uživateli automaticky odeslán email s pozvánkou pro nastavení hesla.</p>
                  <button onClick={pridatUzivatele} disabled={savingU} style={{ background: '#2d6a4f', color: '#fff', border: 'none', borderRadius: 10, padding: '12px', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', marginTop: 4 }}>
                    {savingU ? 'Ukládám…' : '+ Přidat uživatele'}
                  </button>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {uzivatele.map(u => (
                  <div key={u.id} style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', opacity: u.aktivni ? 1 : 0.6, borderLeft: `4px solid ${u.aktivni ? '#2d6a4f' : '#ccc'}` }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 15, color: '#111' }}>{u.jmeno}</div>
                        <div style={{ fontSize: 13, color: '#888', marginTop: 2 }}>{u.email}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {u.google_drive_url && (
                          <a href={u.google_drive_url} target="_blank" rel="noopener noreferrer"
                            style={{ background: '#e8f5e9', color: '#2d6a4f', border: '1px solid #a3cfbb', borderRadius: 8, padding: '4px 10px', fontSize: 12, fontWeight: 600, textDecoration: 'none' }}>
                            📁 Drive
                          </a>
                        )}
                        <span style={{ background: u.aktivni ? '#d8f3dc' : '#f0f0f0', color: u.aktivni ? '#1b4332' : '#888', padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700 }}>
                          {u.aktivni ? 'Aktivní' : 'Neaktivní'}
                        </span>
                      </div>
                    </div>
                    <div style={{ fontSize: 13, color: '#666', marginBottom: 4 }}>
                      {{zamestnanec:'Zaměstnanec', vedouci:'Vedoucí', jednatel:'Jednatel', hr:'HR/Admin'}[u.role]}
                    </div>
                    <div style={{ fontSize: 13, color: '#888', marginBottom: 12 }}>
                      Nárok dovolené: <strong>{u.dovolena_narok ?? 20} dní</strong>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={() => otevritEditaci(u)} style={{ flex: 1, background: '#f0f0f0', color: '#333', border: 'none', borderRadius: 8, padding: '9px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif' }}>✏️ Upravit</button>
                      <button onClick={() => toggleAktivni(u)} style={{ flex: 1, background: u.aktivni ? '#fde8e6' : '#d8f3dc', color: u.aktivni ? '#c0392b' : '#1b4332', border: 'none', borderRadius: 8, padding: '9px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif' }}>{u.aktivni ? 'Deaktivovat' : 'Aktivovat'}</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {tab === 'zakazky' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div style={{ background: '#fff', borderRadius: 14, padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
                <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 14, color: '#111' }}>Přidat zakázku</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                    <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Název zakázky</label>
                    <input value={novaZak.nazev} onChange={e => setNovaZak({...novaZak, nazev: e.target.value})} placeholder="Název zakázky" style={inputStyle} />
                  </div>
                  <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 5, flex: 1 }}>
                      <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Datum zahájení</label>
                      <input type="date" value={novaZak.datum_zahajeni} onChange={e => setNovaZak({...novaZak, datum_zahajeni: e.target.value})} style={inputStyle} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 5, flex: 1 }}>
                      <label style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Datum ukončení (volitelné)</label>
                      <input type="date" value={novaZak.datum_ukonceni} onChange={e => setNovaZak({...novaZak, datum_ukonceni: e.target.value})} style={inputStyle} />
                    </div>
                  </div>
                  <button onClick={pridatZakazku} disabled={savingZ} style={{ background: '#2d6a4f', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 16px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif' }}>+ Přidat zakázku</button>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {zakazky.map(z => (
                  <div key={z.id} style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderLeft: `4px solid ${z.uzavrena ? '#ccc' : '#2d6a4f'}` }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 15, color: '#111' }}>{z.nazev}</div>
                      <div style={{ fontSize: 12, color: '#888', marginTop: 3 }}>
                        {z.datum_zahajeni && `Od: ${z.datum_zahajeni}`}
                        {z.datum_ukonceni && ` · Do: ${z.datum_ukonceni}`}
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <span style={{ background: z.uzavrena ? '#f0f0f0' : '#d8f3dc', color: z.uzavrena ? '#888' : '#1b4332', padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700 }}>{z.uzavrena ? '🔒 Uzavřena' : '✅ Aktivní'}</span>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 8, flexShrink: 0, marginLeft: 12 }}>
                      <button onClick={() => setEditZak({...z, datum_zahajeni: z.datum_zahajeni || '', datum_ukonceni: z.datum_ukonceni || ''})} style={{ background: '#f0f0f0', color: '#333', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif' }}>✏️</button>
                      <button onClick={() => toggleZakazka(z)} style={{ background: z.uzavrena ? '#d8f3dc' : '#fde8e6', color: z.uzavrena ? '#1b4332' : '#c0392b', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif' }}>{z.uzavrena ? 'Otevřít' : 'Uzavřít'}</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {tab === 'tym' && isVedouci && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 4 }}>
                <p style={{ fontSize: 13, color: '#888', margin: 0 }}>Seznam vašich přidělených podřízených. Pro změny kontaktujte HR.</p>
              </div>
              {mojeTym.length === 0 ? (
                <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#888' }}>Nemáte přiřazené žádné podřízené</div>
              ) : (
                mojeTym.map(u => (
                  <div key={u.id} style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', opacity: u.aktivni ? 1 : 0.6, borderLeft: `4px solid ${u.aktivni ? '#2d6a4f' : '#ccc'}` }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 15, color: '#111' }}>{u.jmeno}</div>
                        <div style={{ fontSize: 13, color: '#888', marginTop: 2 }}>{u.email}</div>
                        <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>
                          {{zamestnanec:'Zaměstnanec', vedouci:'Vedoucí', jednatel:'Jednatel', hr:'HR/Admin'}[u.role]}
                        </div>
                      </div>
                      <span style={{ background: u.aktivni ? '#d8f3dc' : '#f0f0f0', color: u.aktivni ? '#1b4332' : '#888', padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700, flexShrink: 0 }}>{u.aktivni ? 'Aktivní' : 'Neaktivní'}</span>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}

          {tab === 'mesice' && isHrOrJednatel && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div style={{ background: '#fff', borderRadius: 14, padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
                <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 6, color: '#111' }}>Uzavřít měsíc</h3>
                <p style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>Po uzavření nelze měnit výkazy. Pouze HR/Admin může znovu otevřít.</p>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  <select value={uzMesic} onChange={e => setUzMesic(+e.target.value)} style={{ border: '1.5px solid #e2e8f0', borderRadius: 8, padding: '8px 12px', fontSize: 14, fontFamily: 'DM Sans, sans-serif', background: '#fff', outline: 'none' }}>
                    {MESICE.map((m, i) => <option key={i} value={i+1}>{m}</option>)}
                  </select>
                  <select value={uzRok} onChange={e => setUzRok(+e.target.value)} style={{ border: '1.5px solid #e2e8f0', borderRadius: 8, padding: '8px 12px', fontSize: 14, fontFamily: 'DM Sans, sans-serif', background: '#fff', outline: 'none' }}>
                    {[2024,2025,2026].map(r => <option key={r} value={r}>{r}</option>)}
                  </select>
                  <button onClick={uzavritMesic} style={{ background: '#1b4332', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif' }}>🔒 Uzavřít</button>
                </div>
              </div>

              {uzavrene.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {uzavrene.map(m => (
                    <div key={m.id} style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 15, color: '#111' }}>🔒 {MESICE[m.mesic-1]} {m.rok}</div>
                        <div style={{ fontSize: 13, color: '#888', marginTop: 2 }}>Uzavřeno {new Date(m.uzavreno_at).toLocaleDateString('cs-CZ')}</div>
                      </div>
                      <button onClick={() => otevritMesic(m.id)} style={{ background: '#fde8e6', color: '#c0392b', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', flexShrink: 0 }}>🔓 Otevřít</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
